module.exports = __webpack_public_path__ + "static/media/brand-refresh-plus.f4ec89dd.svg";